import qrcode from "qrcode-generator";

export function Qr({ text, label = "QR code for the vouch link", testId }: { text: string; label?: string; testId?: string }) {
  const q = qrcode(0, "M");
  q.addData(text);
  q.make();
  return <div className="qr" aria-label={label} data-testid={testId} dangerouslySetInnerHTML={{ __html: q.createSvgTag({ cellSize: 4, margin: 2, scalable: true }) }} />;
}
